module.exports = __webpack_public_path__ + "static/media/LV1@4x.91dc9fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV1@4x.png
// module id = 673
// module chunks = 0